import React, { useEffect, useState } from "react";
import styled from "styled-components";
import BellIcon from "./images/bell-w.svg";
import SubscribeIcon from "./images/BellIcon-2.svg";
import Bg2 from "./images/bg-2.png";
import LogoBg from "./images/cescta_combolog-bg.svg";
import { P } from "../CommonStyle";
import Highlight1 from "./images/highlight1.png";
import CardBgImage from "./images/Card-Bg-Image.png";
import SubscribePopup from "./SubscribePopup";
import { userTrack } from "../Common";
import TopArrow from "./images/scroll-top.svg";
import DwFree from "./images/freeTag.svg";
import Download from "./images/dwnld-w.svg";
import DownloadReport from "./DownloadReport";
import "./Ces.css";
import Link from "next/link";
import Image from "next/image";
import TempHighlightsSecond from "./TempHighlightsSecond";
import { useRouter } from "next/router";
import VerifyEmailAddress from "../VerifyEmail/VerifyEmailAddress";

const HeaderStick = styled.div`
  background-color: #fff;
  box-shadow: 0px 10px 8.2px 0px rgba(0, 0, 0, 0.25);
  position: fixed;
  width: -webkit-fill-available;
  padding-top: 120px;
  z-index: 1;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 72px;
  margin-left: -10px;//-20px;
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  z-index: 2;

  @-moz-document url-prefix() {
    width: -moz-available;
  }
  @media screen and (max-width: 767px) {
    padding: 8px 10px;
  }
`;
const PillWrapCes = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;

  @media screen and (max-width: 767px) {
    gap: 8px;
  }
`;
const PillCont = styled.div`
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: 0.4px solid #acacac;
  padding: 10px 20px;
  border-radius: 24px;
  cursor: pointer;
  -webkit-text-stroke: 0.1px rgb(69, 69, 69);

  -webkit-text-stroke: 0.5px rgb(21, 67, 109);
  background-color: #bddfff;
  border: 0.4px solid #bddfff;

  @media screen and (max-width: 767px) {
    padding: 10px 7px;
    border-radius: 12px;
    text-align: center;
  }
`;

const PillCont1 = styled.div`
  font-family: Roboto;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border: 0.4px solid #acacac;
  padding: 10px 20px;
  border-radius: 24px;
  cursor: pointer;
  -webkit-text-stroke: 0.1px rgb(69, 69, 69);

  &:hover {
    -webkit-text-stroke: 0.5px rgb(21, 67, 109);
    background-color: #bddfff;
    border: 0.4px solid #bddfff;
  }
  @media screen and (max-width: 767px) {
    padding: 10px 7px;
    border-radius: 12px;
    text-align: center;
  }
`;
const SubscribeWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
`;
const TextSub = styled.p`
    margin: 0;
    text-align: right;
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 800;
    line-height: 21px;
    color: #FF7624;
    margin-top: 5px;

    @media screen and (max-width: 767px){
        display: none;
    }
`;
const TextSubG = styled.p`
  margin: 0;
  text-align: right;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 21px;
  color: #454545;

  @media screen and (max-width: 767px) {
    display: none;
  }
`;

const SubButton = styled.div`
  border-radius: 12px;
  border: 2px solid #ff7624;
  background: transparent;
  padding: 12px 8px;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;

  &:hover {
    background-color: #ff76242b;
  }
  @media screen and (max-width: 767px) {
    border: none;
    padding: 0;
    gap: 5px;
  }
`;

const Circle = styled.div`
  height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 767px) {
  }
`;

const ImgBel = styled.div`
  /* width: 74%; */
  margin-top: 7px;
  @media screen and (max-width: 767px) {
    width: 78%;
  }
`;

const TextSubBtn = styled.p`
  margin: 0;
  text-align: center;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  color: #ff7624;

  @media screen and (max-width: 767px) {
    font-size: 13px;
    line-height: 14px;
    text-align: left;
  }
`;

const BannerCes = styled.div`
  background-image: url(${Bg2.src});
  background-size: cover;
  background-repeat: no-repeat;
  height: 720px;
  padding-top: 160px;
  background-position: center;
  /* background: linear-gradient(180deg, rgba(13, 107, 193, 0.75) 18.91%, rgba(0, 0, 0, 0.75) 42.1%); */


  @media screen and (max-width: 1280px) {
    height: 665px;
  }
  @media screen and (max-width: 767px) {
    height: 900px;
  }
`;
const BgCseContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding-top: 10px;

  @media screen and (max-width: 1280px) {
    padding-top: 55px;
  }
`;

const LogoB = styled.div`
  @media screen and (max-width: 767px) {
    width: 80%;
  }
`;
const DwnldBtn = styled.div`
  background-color: #ff7624;
  border-radius: 10px;
  padding: 20px 14px;
  display: flex;
  align-items: center;
  gap: 13px;
  /* width: 325px; */
  width: 230px;
  margin: 0 auto;
  cursor: pointer;
  position: relative;
  /* padding-right: 55px; */

  &:hover {
    background-color: #cd5900;
  }

  @media screen and (max-width: 767px) {
    width: 240px;
  }
`;

const BnrTxtThin = styled.p`
  margin: 0 auto;
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 27px;
  font-style: normal;
  font-weight: 400;
  line-height: 37px;
  margin-top: 10px;
  width: 1125px;

  @media screen and (max-width: 767px) {
    width: auto;
    padding: 0 10px;
    font-size: 25px;
  }
`;
const ContentWrapPadding = styled.div`
  padding: 0 62px;

  @media screen and (max-width: 1280px) {
    padding: 0 17px;
  }
  @media screen and (min-width: 1400px) {
    padding: 0px 125px;
    margin: 0 auto;
    width: 1248px;
  }
  @media screen and (max-width: 767px) {
    padding: 0 20px;
  }
`;
const DivFlex = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 50px;
  margin-top: 100px;

  @media screen and (max-width: 1280px) {
    gap: 27px;
  }
  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;
const ImgHigh = styled.div`
  @media screen and (max-width: 1280px) {
    /* width: 40%; */
    margin: 0 auto;
    img{
      width: 500px;
    }
  }
  @media screen and (max-width: 767px) {
    width: 100%;

    img{
      width: 100%;
    }
  }
`;
const HeaderH = styled.p`
  margin: 0;
  text-align: left;
  font-family: Roboto;
  font-size: 26px;
  font-style: normal;
  font-weight: 500;
  line-height: 44px;
  color: #000000;
  margin-bottom: 30px;

  @media screen and (max-width: 1280px) {
    font-size: 18px;
    width: 611px;
  }
  @media screen and (min-width: 1400px) {
    width: 680px;
  }
  @media screen and (max-width: 767px) {
    text-align: initial;
    width: auto;
  }
`;
const ParaH = styled.p`
  margin: 0;
  text-align: left;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 29px;
  color: #454545;
  margin-bottom: 30px;

  @media screen and (max-width: 1280px) {
    font-size: 17px;
    width: 611px;
  }
  @media screen and (max-width: 767px) {
    width: auto;
  }
`;
const GridWrap = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 100px;
  margin-bottom: 200px;
  margin-top: 70px;

  @media screen and (max-width: 767px) {
    grid-template-columns: auto;
    gap: 0;
    display: flex;
    margin-top: 20px;
    flex-wrap: wrap;
  }
`;
const LiText = styled.li`
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 40px; /* 222.222% */
  letter-spacing: 0.072px;
  color: #454545;
  margin: 0;
  &:hover {
    /* color: #0085ff; */
  }

  @media screen and (max-width: 1280px) {
    font-size: 17px;
  }
  @media screen and (max-width: 767px) {
    font-size: 16px;
  }
`;
const ScrollTop = styled.div`
  float: right;
  margin-top: -70px;
  margin-right: 25px;
  display: ${({ show }) => (show ? "block" : "none")};
`;
const ScrollArrow = styled.div`
  cursor: pointer;
  position: fixed;
  right: 12px;
  bottom: 20px;
`;
const Ul = styled.ul`
  margin: 0;
`;
const BnrTextEDwnld = styled.p`
  margin: 0;
  color: #fff;
  text-align: center;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 44px;
  margin-top: 30px;
  margin-bottom: 30px;
`;
const DwnldBtnTxt = styled.p`
  margin: 0;
  color: #fff;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;

  @media screen and (max-width: 767px) {
    font-size: 16px;
  }
`;
const DwnldImg = styled.div``;

const DwnldFree = styled.div`
  position: absolute;
  top: -2px;
  right: 6px;
`;
const WrapF = styled.div`
  @media screen and (max-width: 767px) {
    flex-wrap: wrap;
    gap: 0 !important;
  }

  @media screen and (max-width: 1280px) {
    margin-left: 20px;
    gap: 0px !important;
  }
`;

const CntBox = styled.div`
  border-radius: 43px;
  border: 0.7px solid #f6f6f6;
  background: #fff;
  box-shadow: 0px 0px 119px 0px rgba(0, 0, 0, 0.15);
  padding: 60px 85px;
  margin: 0 63px;
  margin-top: 60px;

  @media screen and (min-width: 1400px) {
    margin: 0 auto;
    margin-top: 60px;
    width: 1098px;
  }
  @media screen and (max-width: 767px) {
    padding: 37px 10px;
    margin: 0 10px;
  }
`;

const ContLi = styled.li`
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 33px;
  color: #454545;
  margin-bottom: 35px;
`;

const KeyText = styled.div`
    width: 100%;
    /* text-align: center; */
    font-size: 32px;
    font-weight: 600;
    line-height: 44px;
    color: #FF7624;
    margin-bottom: 8px;`;

const KeyHead = styled.div`
font-size: 36px;
font-weight: 700;
line-height: 44px;
color: #FF7624;
margin-top: 35px;

@media screen and (max-width: 1280px) {
    /* font-size: 17px; */
  }
`;

const KeyHeadText = styled.div`
font-family: Roboto;
font-size: 20px;
font-weight: 700;
line-height: 29px;
padding-bottom: 5px;
`;

const Divider = styled.div`
border-bottom: 1px solid #C8C7C7;
    width: 100%;
    padding: 17px 0px;`;
export default function TempCes2004() {
  const [showSub, setShowSub] = useState(false);
  const [show, setShow] = useState(false);
  const router = useRouter();
  const [showVerifyEmail, setShowVerifyEmail] = useState(false);

  useEffect(() => {
    const emailId = router?.query?.emailid;
    const type = router?.query?.type;
    if (type == "subscribe") {
      localStorage.setItem("openSubscribe", true);
      setShowSub(true);
    } else {

    }
  }, [router]);

  useEffect(() => {
    if (!showSub && localStorage.getItem("openSubscribe") == "true") {
      setShowSub(true);
      localStorage.removeItem("openSubscribe");
    }
  }, [showSub]);


  const shown = () => {
    userTrack(
      `${localStorage.storedEmail}`,
      `Clicked on "Download 2024 Report Free" `,
      "CES 2025"
    );
    setShow(true);
  };

  const handelclickNavigate = () => {
    setShowVerifyEmail(true);
    userTrack(`${localStorage.storedEmail}`, "Clicked on view CES 2025 report button", "CES");
  };

  const handelclick = () => {
    window.location.href =
      process.env.NEXT_PUBLIC_SERVER_NAME_URL + "/ces-2024.html";
    userTrack(`${localStorage.storedEmail}`, "Clicked on CES 2024 Tab", "CES");
  };

  const suscribe = () => {
    userTrack(
      `${localStorage.storedEmail}`,
      `Clicked on "Subscribe Now"`,
      "CES 2025"
    );
    // setShowSub(true)
    window.location.href =
      process.env.NEXT_PUBLIC_SERVER_NAME_URL + "/ces-2025.html";
  };

  //This is for subscribe
  const suscribePopup = () => {
    userTrack(
      `${localStorage.storedEmail}`,
      `Clicked on "Subscribe Now"`,
      "CES 2025"
    );
    setShowSub(true);
  };

  const handleScrollToTop = () => {
    userTrack(
      `${localStorage.storedEmail}`,
      "Clicked on Go on top button",
      "CES 2025"
    );
    // Scroll to the top of the web page
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const HandleSearchCompanies = () => {
    userTrack(
      `${localStorage.storedEmail}`,
      "Clicked on Company Profiles CES 2025 Tab",
      "CES"
    );
    window.location.href =
      process.env.NEXT_PUBLIC_SERVER_NAME_URL + "/CES-Company-Profiles.html";
  };
  const categoriesData = [
    {
      title: "Category Group 1",
      items: [
        "3D Printing",
        "5G Technologies",
        "Accessibility",
        "Accessories",
        "AgTech",
        "AR/VR/XR",
        "Artificial Intelligence",
        "Audio",
        "Beauty Tech",
        "Blockchain",
        "Cloud Computing",
        "Construction Tech",
        "Content and EntertaInment",
        "Cryptocurrency",
      ],
    },
    {
      title: "Category Group 2",
      items: [
        "Cybersecurity",
        "Digital Health",
        "Drones",
        "Education Tech",
        "Energy Transition",
        "Energy/Power",
        "Enterprise",
        "Fashion Tech",
        "Fintech",
        "Fitness",
        "Food Tech",
        "Gaming and Esports",
        "Home Entertainment and Office Hardware",
      ],
    },
    {
      title: "Category Group 3",
      items: [
        "Imaging",
        "Investing",
        "IoT/Sensors",
        "Lifestyle",
        "Marketing and Advertising",
        "Metaverse",
        "NFT",
        "Quantum Computing",
        "Retail/E-Commerce",
        "Robotics",
        "Smart Cities",
        "Smart Home and Appliances",
        "Sourcing and Manufacturing",
        "Space Tech",
      ],
    },
    {
      title: "Category Group 4",
      items: [
        "Sports",
        "Startups",
        "Streaming",
        "Supply and Logistics",
        "Sustainability",
        "Travel and Tourism",
        "Vehicle Tech and Advanced Mobility",
        "Video",
      ],
    },
  ];

  const [selectedCategory, setSelectedCategory] = useState("");

  const handleItemClick = (category, item) => {
    // You can store the selected values in your state or perform any other actions.
    setSelectedCategory(item);
  };
  const [showTalkToUsPopup, setShowTalkToUsPopup] = useState(false);
  const [talktousIdentifier, setTalktousIdentifier] = useState('');
  const [reportId, setReportId] = useState("");
  const [reportUrl, setReportUrl] = useState(null);
  const [enteredEmail, setEnteredEmail] = useState("");
  const [verifiedPayload, setVerifiedPayload] = useState({ email: "", reportId: "" });
  const [proceedForVerification, setProceedForVerification] = useState(false);
  const [showScroll, setShowScroll] = useState(false);

  const handleScroll = () => {
    // Show button after user scrolls 200px down
    if (window.scrollY > 200) {
      setShowScroll(true);
    } else {
      setShowScroll(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll); // Clean up on unmount
    };
  }, []);

  return (
    <div>
      {showVerifyEmail && <VerifyEmailAddress directKey={"BHZQAPXY"} setShowTalkToUsPopup={setShowTalkToUsPopup} setTalktousIdentifier={setTalktousIdentifier} setShowVerifyEmail={setShowVerifyEmail} reportId={reportId} setReportId={setReportId} showVerifyEmail={showVerifyEmail} setReportUrl={setReportUrl} reportUrl={reportUrl} enteredEmail={enteredEmail} setEnteredEmail={setEnteredEmail} proceedForVerification={proceedForVerification} setProceedForVerification={setProceedForVerification} setVerifiedPayload={setVerifiedPayload}></VerifyEmailAddress>}

      <HeaderStick>
        <div>
          <PillWrapCes>
            <PillCont>CES 2025</PillCont>
            <PillCont1 onClick={handelclick}>CES 2024</PillCont1>
            <PillCont1 onClick={HandleSearchCompanies}>
              Company Profiles - CES 2025
            </PillCont1>
          </PillWrapCes>
        </div>
        {/* <div>
          <SubscribeWrap>
            <div>
              <TextSubG>
                Ideapoke TechLens
                <br /> CES 2024 Reports are here!
              </TextSubG>
              <TextSub>Ideapoke CES 2024 Report</TextSub>
            </div>
            <div>
              <SubButton onClick={suscribe}>
                <Circle>
                  <ImgBel>
                    <Image src={BellIcon} alt="BellIcon" />
                  </ImgBel>
                </Circle>
                <TextSubBtn>View Reports</TextSubBtn>
              </SubButton>
            </div>
          </SubscribeWrap>
        </div> */}
        <div>
          <SubscribeWrap style={{ visibility: "hidden" }}>
            <div >
              <TextSubG>Get early access to the</TextSubG>
              <TextSub>Ideapoke CES 2025 Report</TextSub>
            </div>
            <div>
              <SubButton onClick={suscribePopup}>
                <Circle>
                  <ImgBel>
                    <Image
                      src={SubscribeIcon}
                      width=""
                      height="40"
                      alt="BellIcon"
                    ></Image>
                  </ImgBel>
                </Circle>
                <TextSubBtn>Subscribe now</TextSubBtn>
              </SubButton>
            </div>
          </SubscribeWrap>

        </div>
      </HeaderStick>

      {/* Banner */}

      <BannerCes alt="CES 2025:Identify new business opportunities, recognize early signals of change and stay on top of the latest trends in the tech world">
        <BgCseContent>
          <LogoB>
            <Image src={LogoBg} alt="LogoBg" />
          </LogoB>
          {/* <P
            text="CES 2025"
            color="#fff"
            fontSize="68px"
            fontWeight="700"
            marginTop="20px"
            mobFontSize="38px"
          ></P> */}
          <P
            text="Ideapoke TechLens CES 2025 Report"
            color="#fff"
            fontSize="68px"
            fontWeight="700"
            marginTop="20px"
            mobFontSize="38px"
          ></P>
          {/* <BnrTxtThin>
            This is where brands get business done, meet new partners and where
            the industry’s sharpest mindstake the stage to unveil their latest
            releases and boldest breakthroughs.
          </BnrTxtThin>
          <BnrTextEDwnld>
            In the meantime, check out the Ideapoke CES 2024 - Trends &
            Innovations report!
          </BnrTextEDwnld> */}
          <BnrTxtThin>
            A comprehensive analysis of Innovative Technologies
            unveiled at CES 2025
          </BnrTxtThin>
          <BnrTextEDwnld>
            Spot new business prospects, detect early signs of
            change, and stay abreast of the latest tech trends.
            <br />
            Explore our TechLens report covering key
            product categories showcased at CES.
          </BnrTextEDwnld>
          <DwnldBtn onClick={handelclickNavigate}>
            {/* <DwnldImg>
              <Image src={Download} alt="Download" />
            </DwnldImg> */}
            <DwnldBtnTxt style={{ paddingLeft: "20px" }}>View 2025 Report</DwnldBtnTxt>
            {/* <DwnldFree>
              <Image src={DwFree} alt="DwFree" />
            </DwnldFree> */}
          </DwnldBtn>
        </BgCseContent>
      </BannerCes>

      <ContentWrapPadding>
        <P
          text="About CES 2025"
          mobFontSize="36px"
          color="#454545"
          fontSize="48px"
          fontWeight="500"
          letterSpacing="-2px"
          marginTop="40px"
        ></P>
        <P
          text="Las Vegas, Nevada — CES 2025 is the most influential tech event in the world and hosted by the Consumer Technology Association (CTA), January 7–10. It brings together leaders, innovators, media, and startups to experience disruptive technologies in areas like AI, smart home technology, sustainability, digital health, and vehicle tech."
          mobFontSize="20px"
          color="#454545"
          fontSize="20px"
          fontWeight="400"
          marginTop="35px"
          lineHeight="33px"
        ></P>
        <P
          text="Immersive Exhibits, Product Launches and Keynote Speeches from Not Just Tech Giants but World Leaders The Innovation Awards are also highlighting the trends and solutions that will ultimately shape our future."
          mobFontSize="20px"
          color="#454545"
          fontSize="20px"
          fontWeight="400"
          marginTop="35px"
          lineHeight="33px"
        ></P>
        <div>
          <CntBox>
            <KeyText>CES Key Highlights 2025 :</KeyText>
            <ul style={{ paddingLeft: "20px" }}>
              <ContLi>
                Generative AI emerges as a key enabler of next-generation
                applications such as smart home devices and personal assistants
                targeting consumers
              </ContLi>
              <ContLi>
                Sustainable Innovations: Environment-friendly tech from
                eco-electronics to energy-saving systems will go into the
                spotlight.
              </ContLi>
              <ContLi>
                Automotive Technology: Sophisticated autonomous driving systems
                and connected car platforms with more robust
                vehicle-to-everything (V2X) communication come into play.
              </ContLi>
              <ContLi>
                Health Tech: Innovative digital solutions for health, such as
                wearable devices that monitor sophisticated biomarkers for
                wellness and disease-preventing activities
              </ContLi>
            </ul>
            <DwnldBtn onClick={handelclickNavigate}>
              {/* <DwnldImg>
              <Image src={Download} alt="Download" />
            </DwnldImg> */}
              <DwnldBtnTxt style={{ paddingLeft: "20px" }}>View 2025 Report</DwnldBtnTxt>
              {/* <DwnldFree>
                <Image src={DwFree} alt="DwFree" />
              </DwnldFree> */}
            </DwnldBtn>
          </CntBox>
        </div>
        <div>
          <P
            text="Here are a few highlights to look out for in CES 2025:"
            color="#454545"
            fontSize="38px"
            fontWeight="600"
            marginTop="100px"
            mobFontSize="34px"
            textAlign="center"
          ></P>
          <DivFlex>
            <ImgHigh>
              <Image
                src={Highlight1}
                alt="Here are a few highlights to look out for in CES 2024:"
              />
            </ImgHigh>
            <div>
              <KeyHead>Smart Sound</KeyHead>
              <HeaderH>
                AI Smart Stethoscope Designed to Revolutionize Medical Staff's
                Treatment Process
              </HeaderH>
              <KeyHeadText>AI-Powered Innovation</KeyHeadText>
              <ParaH>
                Built on integrated edge AI technology to process data onsite
                eliminating security and privacy issues, gaining diagnostic
                support accurate in real-time.
              </ParaH>
              <KeyHeadText>Data Storage Capability</KeyHeadText>
              <ParaH>
                It can save measurement data for more than 500 patients, an
                extensive database of continued monitoring and history.
              </ParaH>
              <KeyHeadText>Barcode Scanning</KeyHeadText>
              <ParaH>
                Embedded with a barcode scanner camera so that it may be used in
                integration with electronic medical records and patient
                identification systems.
              </ParaH>
              <KeyHeadText>All-in-One Design</KeyHeadText>
              <ParaH>
                One device that integrates a range of functionalities, you will
                not have to invest in several different tools / makes for easy
                transport and use extension.
              </ParaH>
              <KeyHeadText>Telemedicine Integration</KeyHeadText>
              <ParaH>
                Enables interworking with telemedicine services, for healthcare
                professionals to be able to derive diagnostic data remotely and
                work together on care of the patient.
              </ParaH>
            </div>
          </DivFlex>
        </div>
        <Divider></Divider>
        <TempHighlightsSecond></TempHighlightsSecond>
        <div>
          <P
            text="Themes to watch out for in CES 2025"
            color="#454545"
            fontSize="48px"
            mobFontSize="36px"
            fontWeight="500"
            letterSpacing="-2px"
            marginTop="120px"
          ></P>
          <GridWrap>
            <WrapF style={{ display: "flex", gap: "25px" }}>
              {categoriesData.map((categoryGroup, groupIndex) => (
                <div key={groupIndex} style={{ width: "300px" }}>
                  <Ul>
                    {categoryGroup.items.map((item, index) => (
                      <LiText
                        key={index}
                      // onClick={() =>
                      //   handleItemClick(categoryGroup.title, item)
                      // }
                      >
                        {/* <Link
                          className="link2004"
                          href={{
                            pathname: "/CES-Company-Profiles.html",
                            query: { selectedCategory: item },
                          }}
                          passHref
                          style={{ textDecoration: "none" }}
                        >
                          {item}
                        </Link> */}
                        <div>{item}</div>
                      </LiText>
                    ))}
                  </Ul>
                </div>
              ))}
            </WrapF>
          </GridWrap>
        </div>
      </ContentWrapPadding>

      {/* Scroll Top */}
      <ScrollTop show={showScroll}>
        <ScrollArrow onClick={handleScrollToTop}>
          <Image src={TopArrow} alt="TopArrow" />
        </ScrollArrow>
      </ScrollTop>

      {showSub && <SubscribePopup setShowSub={setShowSub}></SubscribePopup>}
      {show && <DownloadReport setShowSub={setShow}></DownloadReport>}
    </div>
  );
}
